import * as React from 'react';
import { BuilderOffersNotAvailableDesktop } from '../../components/BuilderOffersNotAvailableDesktop';
import { useSelector } from 'react-redux';
import {
  fromAgentPropsCountDisplaySelector,
  fromAgentsPropsCountUrlSelector,
  gaLabelSelector,
} from '../../selectors/newbuilding';
import { SinglePhone } from '../SinglePhone';
import { CallButton } from '../CallButton';
import { trackOpenContacts, trackShowPhone } from '../../analytics/call';
import { AgentsOffersRow } from '../../components/AgentsOffersRow';

export const BuilderOffersNotAvailable = (): React.JSX.Element => {
  const gaLabel = useSelector(gaLabelSelector);
  const fromAgentsPropsCountDisplay = useSelector(fromAgentPropsCountDisplaySelector);
  const fromAgentsPropsCountUrl = useSelector(fromAgentsPropsCountUrlSelector);

  const handleOpenContacts = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  const handleShowPhone = React.useCallback(() => {
    trackShowPhone('Open_jk_card_blockJK', gaLabel);
  }, [gaLabel]);

  return (
    <div>
      <BuilderOffersNotAvailableDesktop
        contactButton={
          <CallButton
            placeType="blockBuilderCallReasons"
            onShowPhoneClick={handleShowPhone}
            onOpenContactsClick={handleOpenContacts}
            SinglePhoneComponent={SinglePhone}
            openContactsStyles={{ size: 'XS' }}
            showPhoneStyles={{ size: 'XS' }}
          />
        }
      />
      {fromAgentsPropsCountDisplay && (
        <AgentsOffersRow
          fromAgentsPropsCountDisplay={fromAgentsPropsCountDisplay}
          fromAgentsPropsCountUrl={fromAgentsPropsCountUrl as string}
        />
      )}
    </div>
  );
};
